
// import React from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "./index.css";
// import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";

// import Home from "./pages/home/home";
// import Productdetails from "./pages/product-details/productdetails";
// import Productgrid from "./pages/product-grid/productgrid";
// import Contactus from "./pages/contactus/contactus";
// import Offer from "./pages/offers/offer";
// import AboutUs from "./pages/aboutus/aboutus";
// import Login from "./pages/login/login";
// import Signup from "./pages/signup/signup";
// import Cart from "./pages/cart/cart";
// import Checkout from "./pages/checkout/checkout";
// import Brands from "./pages/brands/brands";
// import OrderTracking from "./pages/ordertraking/OrderTracking"; 
// import OrderSuccess from "./pages/OrderSuccess/OrderSuccess";
// import AdminHome from "./dashboard/components/home/home";
// import AdminLogin from "./pages/login/login"; // Adjust if your path is different
// import AdminProduct from "./dashboard/components/product/product"; 

// // 👇 1. Import the new LoginSuccess component
// import LoginSuccess from "./pages/LoginSuccess/LoginSuccess"; 

// /* ✅ CREATE guestId ONCE */
// let guestId = localStorage.getItem("guestId");
// if (!guestId) {
//   guestId = crypto.randomUUID();
//   localStorage.setItem("guestId", guestId);
// }

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
//     <Routes>
//       <Route path="/" element={<Home />} />
//       <Route path="/aboutus" element={<AboutUs />} />

//       <Route path="/product-details/:id" element={<Productdetails />} />
//       <Route path="/product/:category/:subcategory" element={<Productdetails />} />

//       <Route path="/shop" element={<Productgrid />} />
//       <Route path="/offers" element={<Offer />} />
//       <Route path="/contactus" element={<Contactus />} />
//       <Route path="/login" element={<Login />} />
      
//       {/* 👇 2. Use the imported component here */}
//       <Route path="/login-success" element={<LoginSuccess />} />

//       <Route path="/signup" element={<Signup />} />
//       <Route path="/cart" element={<Cart />} />
//       <Route path="/checkout" element={<Checkout />} />
//       <Route path="/brands" element={<Brands />} />

//       <Route path="/track/:orderNumber?" element={<OrderTracking />} />
//       <Route path="/order-success" element={<OrderSuccess />} />

//       <Route path="/category" element={<Productgrid />} />
//       <Route path="/category/:category" element={<Productgrid />} />
//       <Route path="/products" element={<Productgrid />} />
//       <Route path="/admin" element={<AdminLogin />} />
//       <Route path="/admin/dashboard" element={<AdminHome />} />
//       <Route path="/admin/products" element={<AdminProduct />} />
//     </Routes>
//   </Router>,
// );

// reportWebVitals();

// // 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


import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

import Home from "./pages/home/home";
import Productdetails from "./pages/product-details/productdetails";
import Productgrid from "./pages/product-grid/productgrid";
import Contactus from "./pages/contactus/contactus";
import Offer from "./pages/offers/offer";
import AboutUs from "./pages/aboutus/aboutus";
import Login from "./pages/login/login";
import Signup from "./pages/signup/signup";
import Cart from "./pages/cart/cart";
import Checkout from "./pages/checkout/checkout";
import Brands from "./pages/brands/brands";
import OrderTracking from "./pages/ordertraking/OrderTracking";
import OrderSuccess from "./pages/OrderSuccess/OrderSuccess";
import AdminHome from "./dashboard/components/home/home";
import AdminLogin from "../src/dashboard/components/login/login";
import AdminProduct from "./dashboard/components/product/product";
import LoginSuccess from "./pages/LoginSuccess/LoginSuccess";
import Signin from "./dashboard/components/signin/singin"; // Adjust if your path is different
// 👇 NEW: Pre-booking page
import PreBooking from "./pages/PreBookingForm/PreBookingForm";

let guestId = localStorage.getItem("guestId");
if (!guestId) {
  guestId = crypto.randomUUID();
  localStorage.setItem("guestId", guestId);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/aboutus" element={<AboutUs />} />

      <Route path="/product-details/:id" element={<Productdetails />} />
      <Route path="/product/:category/:subcategory" element={<Productdetails />} />

      <Route path="/shop" element={<Productgrid />} />
      <Route path="/offers" element={<Offer />} />
      <Route path="/contactus" element={<Contactus />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login-success" element={<LoginSuccess />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/brands" element={<Brands />} />

      <Route path="/track/:orderNumber?" element={<OrderTracking />} />
      <Route path="/order-success" element={<OrderSuccess />} />

      <Route path="/category" element={<Productgrid />} />
      <Route path="/category/:category" element={<Productgrid />} />
      <Route path="/products" element={<Productgrid />} />

      {/* 👇 NEW: iPhone 18 pre-booking */}
      <Route path="/pre-booking" element={<PreBooking />} />

      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminHome />} />
      <Route path="/admin/products" element={<AdminProduct />} />
      {/* <Route path="/admin/signup" element={<AdminSignup />} /> */}
      <Route path="/admin/signin" element={<Signin />} />
    </Routes>
  </Router>,
);

reportWebVitals();